// @flow

import type { SocialObjectReferenceGql } from '@ta/social.types';
import { useInvalidatableQuery } from '@ta/platform.urql';
import IsLiked from './IsLiked.gql';

type LikeStats = {|
  isLiked: boolean,
  likeCount: number,
|};

const useUpdatedRepostStats: (socialObject: SocialObjectReferenceGql) => ?LikeStats = (
  socialObject: SocialObjectReferenceGql,
) => {
  const shouldInvalidate = (socialObjRefGql: SocialObjectReferenceGql) =>
    String(socialObjRefGql.objectId) === String(socialObject.objectId) &&
    socialObjRefGql.objectType === socialObject.objectType
      ? 'invalidateAndRefetch'
      : 'validate';

  const [{ data, fetching, error }] = useInvalidatableQuery(
    {
      query: IsLiked,
      variables: {
        socialObjects: [socialObject],
      },
      executeWhen: 'afterInvalidation',
    },
    {
      addLikeV2: shouldInvalidate,
      deleteLikeV2: shouldInvalidate,
    },
  );

  return (
    (!fetching &&
      !error &&
      data &&
      data.socialStatistics &&
      data.socialStatistics.length &&
      data.socialStatistics[0]) ||
    null
  );
};

export default useUpdatedRepostStats;
